<template>
  <div class="section-main__warp">
    <div class="roster-manage-page">
      <!-- 布控状态按钮组 -->
      <div class="table-tool">
        <el-button type="text" class="iss-operation-button" icon="el-icon-plus" @click="createControl" v-auth="'/carPatrol/index:add'">
          {{ $t('carPatrol.button.create') }}
        </el-button>
        <el-button
          type="text"
          class="iss-operation-button"
          icon="iconfont icon-qiyong"
          @click="startControlNums(1)"
          v-auth="'/carPatrol/index:startStop'"
        >
          {{ $t('carPatrol.button.start') }}
        </el-button>
        <el-button
          type="text"
          class="iss-operation-button"
          icon="iconfont icon-jinyong1"
          @click="prohibitControlNums(2)"
          v-auth="'/carPatrol/index:startStop'"
        >
          {{ $t('carPatrol.button.disable') }}
        </el-button>
      </div>
      <div style="display:flex;align-items:center;flex-wrap: wrap;margin-left:20px">
        <div style="display:flex;align-items:center;margin:5px 0 5px 0;width:20%">
          <div style="margin-right:8px">布控名称</div>
          <div style="flex:2;margin-right:8px">
            <el-input placeholder="请输入布控名称" v-model="searchData.name"></el-input>
          </div>
        </div>
        <div style="display:flex;align-items:center;margin:8px 0 8px 0;width:22%">
          <div style="margin-right:8px">布控状态</div>
          <div style="flex:1;margin-right:8px">
            <el-select placeholder="请选择" style="width:100%" v-model="searchData.status">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
        </div>
        <div style="display:flex;align-items:center;margin:5px 0 5px 0;width:22%">
          <div style="margin-right:8px">布控对象</div>
          <div style="flex:1;margin-right:8px;position:relative">
            <el-select style="width:200px" v-model="searchData.repositoriesCode" placeholder="请选择" filterable multiple collapse-tags>
              <el-option style="width:200px" v-for="item in faceGroup" :key="item.value" :label="item.name" :value="item.code"> </el-option>
            </el-select>
          </div>
        </div>
        <div style="display:flex;align-items:center;margin:5px 0 5px 0;width:22%">
          <div style="margin-right:8px">摄像机组</div>
          <div style="flex:1;margin-right:8px;position:relative">
            <el-input placeholder="请选择" @click.native="sxjz" v-model="searchData.bayonetList" class="bukongObject"></el-input>
            <div
              v-if="groupList"
              style="background:#383f6e;position:absolute;bottom:-205px;width:100%;z-index:999999;height:200px;box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.4);"
            >
              <div style="position:relative;height:100%;background:#23365d">
                <app-camers-group
                  type="1"
                  :bayonetListType="2"
                  @changeCamersGroup="changeCamersGroup"
                  :isRequired="true"
                  style="width:100%;height:100%;position;inherit;right:0;top:0"
                >
                </app-camers-group>
              </div>
            </div>
          </div>
        </div>
        <div style="display:flex;align-items:center;">
          <div style="flex:1;padding-right:8px">
            <el-button type="text" class="iss-operation-button" @click="searchTask">
              查询
            </el-button>
          </div>
          <div style="flex:1">
            <el-button type="text" class="iss-reset-button" @click="resetform">
              重置
            </el-button>
          </div>
        </div>
      </div>
      <!-- 布控任务展示 -->
      <ioc-table
        :option="optionTabTask"
        :data="taskCenterData"
        :page="page"
        @size-change="sizeChange"
        @current-change="currentChange"
        @selection-change="handleSelectionChange"
        ref="crud"
      >
        <!-- 布控列表-按钮操作栏 -->
        <template slot="menu" slot-scope="scope">
          <el-tooltip
            class="item m5"
            effect="dark"
            :content="$t('carPatrol.placeholder.delete')"
            placement="top-start"
            v-auth="'/carPatrol/index:delete'"
          >
            <span class="icon iconfont icon-blue icon-shanchu" @click="deleteControl(scope.row)"></span>&nbsp;&nbsp;&nbsp;&nbsp;
          </el-tooltip>
          <el-tooltip
            class="item m5"
            effect="dark"
            v-if="scope.row.status === 2"
            :content="$t('carPatrol.placeholder.enabled')"
            placement="top-start"
          >
            <span class="icon iconfont icon-blue icon-qiyong" @click="openControl(scope.row, 1)" v-auth="'/carPatrol/index:startStop'"></span
            >&nbsp;&nbsp;&nbsp;&nbsp;
          </el-tooltip>
          <el-tooltip
            class="item m5"
            effect="dark"
            v-if="scope.row.status === 1"
            :content="$t('carPatrol.placeholder.disable')"
            placement="top-start"
          >
            <span class="icon iconfont icon-blue icon-jinyong1" @click="openControl(scope.row, 2)" v-auth="'/carPatrol/index:startStop'"></span
            >&nbsp;&nbsp;&nbsp;&nbsp;
          </el-tooltip>
        </template>
      </ioc-table>
    </div>
    <!-- 名单组选择弹框 -->
    <app-person-group-list ref="appPersonGroupList" @group="groupChange" />
    <el-dialog v-dialogDrag :title="$t('deviceMg.title.add')" :visible.sync="controlWindowShow" :modal="false" @close="cancelForm('ruleForm')" width="780px">
      <el-form :inline="true" ref="ruleForm" label-width="120px" :model="formNew" :rules="rules" :status-icon="true">
        <el-form-item :label="$t('personCm.label.name')" prop="name" style="width: 45%;">
          <el-input v-model="formNew.name" :placeholder="$t('personCm.placeholder.name')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('personCm.label.object')" prop="object" style="width: 45%;position:relative">
          <el-select style="width:200px" v-model="formNew.repositoriesCode" placeholder="请选择" filterable multiple collapse-tags>
            <el-option style="width:200px" v-for="item in faceGroup" :key="item.value" :label="item.name" :value="item.code"> </el-option>
          </el-select>
        </el-form-item>
        <!-- 摄像机组 -->
        <el-form-item :label="$t('personCm.label.cameraGroup')" prop="bayonetList" style="width: 45%;">
          <!-- <el-input v-model="formNew.cameraGroup" readonly="true"></el-input> -->
          <el-input placeholder="请选择" @click.native="sxjzList" class="bukongObject" v-model="showBayonetList"></el-input>
          <div
            v-if="groupListCreate"
            style="background:#383f6e;position:absolute;bottom:-205px;width:100%;z-index:999999;height:200px;box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.4);"
          >
            <div style="position:relative;height:100%;background:#23365d">
              <app-camers-group
                type="1"
                @changeCamersGroup="changeCamersGroup"
                :isRequired="true"
                style="width:100%;height:100%;position;inherit;right:-10px;top:0"
              ></app-camers-group>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('personCm.label.describe')" style="width: 100%;">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="formNew.description"
            style="background:#191d31;width:350px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('ruleForm')">
          {{ $t('deviceMg.button.save') }}
        </el-button>
        <el-button @click="cancelForm('ruleForm')">
          {{ $t('deviceMg.button.Cancel') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from '../api'
import utils from '@src/common/utils'

import { Dates, Dic, Data } from '$utils'
// 查询条件的配置
import { SearchFilter } from '../options/searchColumn'
// 表格的配置
import { tableColumn } from '../options/tableColumn'
// 数据映射
import { mapping } from '../options/mapping'

import appPersonGroupList from '@src/components/business/app-person-group-list'
import appCamersGroup from '@components/app-camera-group'
// import blackList from './Blacklist'
export default {
  components: {
    appPersonGroupList,
    appCamersGroup,
    // blackList
  },
  data() {
    return {
      faceGroup: [],
      formNew: {
        name: '',
        confidenceThreshold: 50,
        type: 0,
        repositoriesCode: '',
        // groupList:[{
        //   repositoriesCode: ''
        // }],
        bayonetList: [],
        bayonetParams: [],
        description: '',
      },
      faceSetId: '',
      flagObject: false,
      groupList: false,
      controlObject: false,
      groupListCreate: false,
      createControlObject: false,
      controlWindowShow: false,
      tableLoading: false,
      repositoriesName: '',
      //   搜索表单的数据
      formData: {
        // 布控名称
        controlName: '',
        // 默认状态是不限
        enable: '',
        // 时间段
        daterange: [],
        repositoriesCode: '',
      },
      searchData: {
        // 布控名称
        controlName: '',
        // 默认状态是不限 1：启用，2：不启用，3：不限
        status: 3,
        // 默认状态是不限
        enable: '',
        // 时间段
        daterange: [],
        repositoriesCode: '',
        bayonetList: '',
        type: 2,
      },
      statusList: [
        {
          label: '启用',
          value: 1,
        },
        {
          label: '禁用',
          value: 2,
        },
        {
          label: '全部',
          value: 3,
        },
      ],
      groupSelect: null,
      checkedData: [],
      //  搜索表单的配置
      optionForm: {
        //让自带的提交和清空按钮隐藏
        submitBtn: false,
        emptyBtn: false,
        submitPosition: 'center',
        submitText: this.$t('carPatrol.button.submit'),
        labelPosition: 'left',
        span: 12,
        clearable: true,
        menuBtn: false,
        labelWidth: 100,
        column: SearchFilter(),
      },
      rules: {
        name: [{ required: true, message: '请输入布控名称' }],
        threshold: [{ required: true }],
        type: [{ required: true, message: '请选择布控类型' }],
        faceTime: [{ required: true }],
        repositoriesCode: [{ required: true, message: '请选择布控对象' }],
        faceNum: [{ required: true }],
        bayonetList: [{ required: true, message: '请选择摄像机组' }],
        pictureQuality: [{ required: false }],
      },
      centerDialogVisible: false, // 启用布控
      // 存储布控任务的数据
      taskCenterData: [],
      page: {
        // 当前页
        currentPage: 1,
        // 查询记过总计
        total: 0,
        // 每页默认显示条数
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      //  表格任务的的配置项
      optionTabTask: {
        addBtn: false,
        refreshBtn: false,
        searchBtn: false,
        stripe: true,
        page: true,
        maxHeight: '100%',
        editBtn: false,
        delBtn: false,
        header: false,
        emptyText: this.$t('carPatrol.label.nodata'),
        // 行可勾选
        selection: true,
        column: tableColumn(),
        faceGroup: [],
      },
    }
  },
  computed: {
    showBayonetList() {
      return this.formNew.bayonetList.join(', ')
    },
  },
  watch: {
    checkedData(val) {
      const length = val.length
      if (!length) {
        return false
      }
      if (length === this.taskCenterData.length) {
        setTimeout(() => {
          $('.el-table__fixed-header-wrapper label.el-checkbox>span').attr('class', 'el-checkbox__input is-checked')
        })
      } else {
        setTimeout(() => {
          $('.el-table__fixed-header-wrapper label.el-checkbox>span').attr('class', 'el-checkbox__input is-indeterminate')
        })
      }
    },
  },
  mounted() {
    this.queryVehicleGroup()
    document.addEventListener('click', (data) => {
      console.log('data', data.target.nodeName)
      if (data.target.nodeName != 'INPUT' && data.target.nodeName != 'I') {
        this.groupListCreate = false
        this.createControlObject = false
        this.flagObject = false
        this.groupList = false
      }
      // this.groupListCreate = false;
      // this.createControlObject = false;
      // this.flagObject = false;
      // this.groupList = false;
    })
    this.queryControlTask()
  },
  methods: {
    /*
     *@name: 清除选中名单组
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 16:37:25
     */
    clearGroup() {
      this.formData.repositoriesCode = ''
      this.repositoriesName = ''
      this.groupSelect = null
    },
    /*
     *@name: 名单组选中回填
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 16:17:58
     */
    groupChange(data) {
      this.repositoriesName = `${data.type.label}：${data.group.name}`
      this.formData.repositoriesCode = data.group.code
      this.groupSelect = data.type
    },
    /*
     *@name: 打开名单组选取控件
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-07-12 14:51:33
     */
    openPersonGroup() {
      if (this.groupSelect) {
        this.$refs['appPersonGroupList'].open(
          2,
          [{ label: this.$t('carPatrol.label.blackGroup'), value: 2 }],
          this.groupSelect.value,
          this.formData.repositoriesCode
        )
      } else {
        this.$refs['appPersonGroupList'].open(2, [{ label: this.$t('carPatrol.label.blackGroup'), value: 2 }], 2)
      }
    },
    searchTask() {
      this.page.currentPage = 1
      // this.searchData = JSON.parse(JSON.stringify(this.formData))
      this.queryControlTask()
    },
    // 查询布控任务接口
    queryControlTask() {
      // console.log('aaaaaaaaaaaaa',this.searchData)
      const _this = this
      // 基础参数
      let baseParams = {
        pageNum: _this.page.currentPage,
        pageSize: _this.page.pageSize,
      }
      // 布控查询相关参数
      let controlParams = {}
      // 布控名称
      controlParams.name = _this.searchData.name
      // 布控状态
      controlParams.status = _this.searchData.status
      // 布控名单组
      controlParams.repositoriesCode = _this.faceSetId

      let daterange = _this.searchData.daterange

      if (daterange && daterange.length) {
        controlParams.startTime = Dates.dayjs(daterange[0]).format('YYYY-MM-DD')
        controlParams.endTime = Dates.dayjs(daterange[1]).format('YYYY-MM-DD')
      }
      this.tableLoading = true
      this.$fetch(api.task.queryVehicleTask, _.merge(baseParams, controlParams)).then((response) => {
        this.tableLoading = false
        if (response.success) {
          _this.taskCenterData = response.returnObj.list || []
          _this.page.total = response.returnObj.total
          this.$refs['crud'].selectClear()
        } else {
          _this.$message({
            message: response.msgContent,
            type: 'error',
          })
        }
      })
    },
    // 重置表单并查询任务
    resetform() {
      // this.$refs.form.resetForm()
      // this.clearGroup()
      this.searchData = JSON.parse(JSON.stringify(this.formData))
      console.log('this.searchData', this.searchData)
      this.faceSetId = ''
      //   刷新列表
      this.queryControlTask()
    },
    // 创建布控任务
    createControl() {
      this.controlWindowShow = true
      // this.$router.push({
      //     path: '/view/create',
      //     name: 'create'
      // })
      // localStorage
      // sessionStorage
    },
    // 编辑布控任务接口
    editControl(row) {
      this.$router.push({
        path: '/view/edit',
        name: 'edit',
        query: {
          // 这一行的所有数据
          code: row.code,
        },
      })
    },
    // 删除布控
    deleteControl(row, index) {
      if (row.status == 1) {
        return this.$message({
          message: this.$t('carPatrol.message.unableDelete'),
          type: 'warning',
          showClose: true,
        })
      }
      let controlTaskList = []
      controlTaskList.push(row.code)
      this.$confirm(this.$t('carPatrol.message.deleteWarn'), this.$t('carPatrol.title.remind'), {
        confirmButtonText: this.$t('carPatrol.button.confirm'),
        cancelButtonText: this.$t('carPatrol.button.cancel'),
        type: 'warning',
      }).then(() => {
        this.$fetch(api.task.deleteVehicleTask, {
          controlTaskList,
        }).then((res) => {
          if (res.success) {
            this.queryControlTask()
            this.$message.success(this.$t('carPatrol.message.deleteOk'))
          } else {
            this.$message.error(res.msgContent)
          }
        })
      })
    },
    // 启用布控任务禁用调统一接口
    openControl(row, status) {
      let controlTaskList = []
      controlTaskList.push(row.code)
      let params = {
        controlTaskList,
        status,
      }
      let stateLable = ''
      if (status === 1 && row.status != 1) {
        stateLable = this.$t('carPatrol.message.startWarn')
      }
      if (status === 2) {
        stateLable = this.$t('carPatrol.message.disableWarn')
      }
      this.$confirm(stateLable, this.$t('carPatrol.title.remind'), {
        confirmButtonText: this.$t('carPatrol.button.confirm'),
        cancelButtonText: this.$t('carPatrol.button.cancel'),
        type: 'warning',
      })
        .then(() => {
          this.$fetch(api.task.openCloseVehicleTask, params).then((response) => {
            if (!response.success) {
              this.$message.error(response.msgContent)
              return
            }
            if (status === 1) {
              this.$message.success(this.$t('carPatrol.title.successStart'))
            } else if (status === 2) {
              this.$message.success(this.$t('carPatrol.title.successDisable'))
            }
            this.queryControlTask()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('carPatrol.title.cancel'),
          })
        })
    },
    // 批量启用布控
    startControlNums(status) {
      if (!this.checkedData.length && status === 1) {
        // 是否选中
        this.$message.warning(this.$t('carPatrol.message.batchStart'))
        return
      }
      let or = true
      this.checkedData.map((item) => {
        // 启用停止
        if (item.status === 1) {
          or = false
        }
      })
      // if (!or) {
      //     this.$message.warning(this.$t('carPatrol.message.starting'))
      //     return false
      // }
      let controlTaskList = []
      this.checkedData.map((item) => {
        if (item.status !== 1) {
          controlTaskList.push(item.code)
        }
      })
      let param = {
        controlTaskList,
        status: status,
      }
      this.$confirm(this.$t('carPatrol.message.someStart'), this.$t('carPatrol.title.remind'), {
        confirmButtonText: this.$t('carPatrol.button.confirm'),
        cancelButtonText: this.$t('carPatrol.button.cancel'),
        type: 'warning',
      }).then(() => {
        this.$fetch(api.task.openCloseVehicleTask, param).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent)
            return false
          }
          this.$message.success(this.$t('carPatrol.title.successStart'))
          this.$refs['crud'].selectClear()
          this.queryControlTask()
        })
      })
    },
    // 批量禁用布控
    prohibitControlNums(status) {
      console.log('status__批量禁用布控', status)
      console.log('this.checkedData', this.checkedData)
      if (!this.checkedData.length && status === 2) {
        // 是否选中
        this.$message.warning(this.$t('carPatrol.message.batchDisable'))
        return
      }
      let or = true
      this.checkedData.map((item) => {
        // 启用停止
        if (item.status === 2) {
          or = false
        }
      })
      // if (!or) {
      //     this.$message.warning(this.$t('carPatrol.message.disableing'))
      //     return false
      // }
      let controlTaskList = []
      this.checkedData.map((item) => {
        if (item.status !== 2) {
          controlTaskList.push(item.code)
        }
      })
      let param = {
        controlTaskList,
        status: status,
      }
      this.$confirm(this.$t('carPatrol.message.someDisable'), this.$t('carPatrol.title.remind'), {
        confirmButtonText: this.$t('carPatrol.button.confirm'),
        cancelButtonText: this.$t('carPatrol.button.cancel'),
        type: 'warning',
      }).then(() => {
        // console.log('param',param)
        this.$fetch(api.task.openCloseVehicleTask, param).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent)
            return false
          }
          this.$message.success(this.$t('carPatrol.title.successDisable'))
          this.$refs['crud'].selectClear()
          this.queryControlTask()
        })
      })
    },
    // 批量删除布控
    batchDelete() {
      if (!this.checkedData.length) {
        this.$message.info(this.$t('carPatrol.message.batchDelete'))
        return
      }
      let controlTaskList = []

      this.checkedData.map((item) => {
        controlTaskList.push(item.code)
      })
      this.$confirm(this.$t('carPatrol.message.someDelete'), this.$t('carPatrol.title.remind'), {
        confirmButtonText: this.$t('carPatrol.button.confirm'),
        cancelButtonText: this.$t('carPatrol.button.cancel'),
        type: 'warning',
      }).then(() => {
        this.$fetch(api.task.deleteVehicleTask, {
          controlTaskList,
        }).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent)
            return false
          }
          this.$message.success(this.$t('carPatrol.message.deleteOk'))
          this.queryControlTask()
          this.$refs['crud'].selectClear()
        })
      })
    },
    // 每页显示条数发生变化，页码为1，再次刷新表格
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.queryControlTask()
    },
    // 页码发生改变
    currentChange(val) {
      this.page.currentPage = val
      this.queryControlTask()
    },
    handleSelectionChange(items) {
      this.checkedData = items.map((item) => {
        return item
      })
    },
    // 布控详情
    openDetails(row) {
      console.log(row)
      this.$router.push({
        path: '/view/detail',
        name: 'detail',
        query: {
          code: row.code,
        },
      })
    },
    showControlObject() {
      // this.controlObject = true;
    },
    hideControlObject() {
      // this.controlObject = false;
    },
    bkdx() {
      this.flagObject = !this.flagObject
      // this.controlObject = !this.controlObject
    },
    showGroupList() {
      // this.groupList = true;
    },
    hideGroupList() {},
    sxjz() {
      this.groupList = !this.groupList
    },
    sxjzList() {
      this.groupListCreate = !this.groupListCreate
    },
    createBkdx() {
      this.flagObject = false
      this.createControlObject = !this.createControlObject
    },
    changeObject(data) {
      console.log('data', data)
      this.faceSetId = data.code
      if (this.flagObject) {
        this.searchData.repositoriesCode = data.name
        this.bkdx()
      } else {
        this.formNew.repositoriesCode = data.name
        this.createControlObject = !this.createControlObject
      }
      //   console.log('data', data);
      //   this.formData.repositoriesCode = data.name;
      //   this.bkdx()
    },
    changeCamersGroup(data, type) {
      console.log('set', data)
      console.log('type', type)
      if (type === 2) {
        this.searchData.bayonetList = ''
        this.searchData.bayonetParams = []
        data.map((val) => {
          this.searchData.bayonetList.push(val.bayonetName)
          this.searchData.bayonetParams.push(val.code)
        })
      } else if (type === 1) {
        this.formNew.bayonetList = ''
        this.formNew.bayonetParams = []
        data.map((val) => {
          console.log('val', val)
          this.formNew.bayonetList.push(val.bayonetName)
          this.formNew.bayonetParams.push(val.code)
        })
        console.log('this.formNew.bayonetList', this.formNew.bayonetList)
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        console.log('valid', valid)
        if (valid) {
          console.log('this.formNew', this.formNew)
          let params = {}
          params.groupList = []
          params.bayonetList = []
          params.name = this.formNew.name
          params.parkId = '200000001'
          params.desc = this.formNew.description
          this.formNew.repositoriesCode.map((item) => {
            params.groupList.push({
              repositoriesCode: item,
            })
          })
          this.formNew.bayonetParams.map((val) => {
            params.bayonetList.push({
              bayonetCode: val,
            })
          })
          this.$fetch(api.task.addVehicleTask, params).then((res) => {
            if (res.success) {
              this.controlWindowShow = false
              this.faceSetId = ''
              this.queryControlTask()
            } else {
              this.$message.error(res.msgContent)
            }
          })
        } else {
          return false
        }
      })
    },
    cancelForm(formName) {
      this.formNew.repositoriesCode = ''
      this.formNew.description = ''
      this.$refs[formName].resetFields()
      this.controlWindowShow = false
    },
    queryVehicleGroup() {
      let params = {
        // name: this.paramsBlackList.listName
      }
      this.$fetch(api.task.queryVehicleGroup, params).then((res) => {
        if (res.success) {
          this.faceGroup = res.returnObj.list
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '../style/controlmanage.scss';
</style>
<style lang="scss">
@import '../style/Index.scss';
.carPatrol.carPatrolBlack-container.person-mg_carPatrol {
  .list-content {
    .right-name {
      .el-form-item__content {
        overflow: hidden;
        word-break: keep-all;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
<style>
.el-textarea__inner {
  background: #191d31;
}
.ioc-theme .el-tree .el-tree-node .el-tree-node__content {
  /* background: #23365e; */
}
.el-message-box {
  background-color: #262a49;
}
</style>
